import { Lozenge } from 'shared/lozenge/Lozenge';
import { useThemeValues } from 'styles/theme';

export type KCFOnlyLozengeProps = {
    id?: string;
};

export function KCFOnlyLozenge({ id }: KCFOnlyLozengeProps) {
    const { kcfOnlyLozengeText, kcfOnlyLozengeBackground } = useThemeValues();

    return (
        <Lozenge
            id={id}
            color={kcfOnlyLozengeText}
            backgroundColor={kcfOnlyLozengeBackground}
        >
            KCF
        </Lozenge>
    );
}
